import Vue from 'vue';

// vee-select
import vSelect from 'vue-select';

vSelect.props.components.default = () => ({
  Deselect: {
    render: () => null
  },
  OpenIndicator: {
    render: () => null // 화살표 제거
    /* render: (createElement) =>
      createElement('img', {
        attrs: {
          src: `${resources}img/ico_arrow_bot.png`
        }
      }) */
  }
});

Vue.component('v-select', vSelect);

// vee-validate
import {
  ValidationProvider,
  ValidationObserver,
  extend,
  configure
} from 'vee-validate';
import { required, email } from 'vee-validate/dist/rules';

configure({
  classes: {
    invalid: 'error'
  }
});

extend('required', required);
extend('email', email);

Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);
